import { SchoolMoodQuery, SchoolMoodQueryVariables } from '@/graphql/generated/graphql';
import { SCHOOL_MOOD } from '@/graphql/queries/report/ga-interactions';
import { useQuery } from '@apollo/client';
import { useDashboardStore } from '../../store/useDashboardStore';

function calculateOverallMood(schoolMood: SchoolMoodQuery['getSchoolMood'] | null) {
  if (!schoolMood) return null;

  const emotionGroup: {
    [key: string]: { count: number; overallMoodIcon: string | null };
  } = {
    positive: { count: 0, overallMoodIcon: null },
    negative: { count: 0, overallMoodIcon: null },
    neutral: { count: 0, overallMoodIcon: null },
    surprised: { count: 0, overallMoodIcon: null },
  };

  schoolMood.forEach((school) => {
    if (!school?.emotions) return;

    school.emotions.forEach((emotion) => {
      if (!emotion?.type || !emotion.count) return;

      const overallMoodIcon = emotion.overallMoodIcon ?? null;

      switch (emotion.type) {
        case 'POSITIVE':
          emotionGroup.positive.count += emotion.count;
          emotionGroup.positive.overallMoodIcon = overallMoodIcon;
          break;
        case 'NEGATIVE':
          emotionGroup.negative.count += emotion.count;
          emotionGroup.negative.overallMoodIcon = overallMoodIcon;
          break;
        case 'LOW_ACTIVATION':
          emotionGroup.neutral.count += emotion.count;
          emotionGroup.neutral.overallMoodIcon = overallMoodIcon;
          break;
        case 'HIGH_ACTIVATION':
          emotionGroup.surprised.count += emotion.count;
          emotionGroup.surprised.overallMoodIcon = overallMoodIcon;
          break;
        default:
          break;
      }
    });
  });

  const maxMoodType = Object.keys(emotionGroup).reduce((maxType, currentType) => {
    return emotionGroup[currentType].count > emotionGroup[maxType].count ? currentType : maxType;
  }, 'neutral');

  return emotionGroup[maxMoodType].overallMoodIcon;
}

export default function Header() {
  const renderMood = (mood: string) => {
    return <img src={mood} alt="Mood Icon" className="h-[25px] w-[25px]" />;
  };

  const { getDateRange, schoolsIds } = useDashboardStore();

  const { data: response, loading } = useQuery<SchoolMoodQuery, SchoolMoodQueryVariables>(SCHOOL_MOOD, {
    variables: {
      startDate: getDateRange()?.startDate,
      endDate: getDateRange()?.endDate,
      schoolsIds,
    },
  });

  const mood = response && response.getSchoolMood;

  const overallMood = calculateOverallMood(mood);

  if (loading) {
    return (
      <p>
        <div className="size-10 animate-pulse rounded-md bg-gray-300"></div>
      </p>
    );
  }

  return (
    <p className=" text-sh-md font-bold">
      {overallMood ? renderMood(overallMood) : <div className="size-10 rounded-full  text-center ">-</div>}
    </p>
  );
}
